import { render, staticRenderFns } from "./GlobalSetting.vue?vue&type=template&id=2a7b40c5&scoped=true"
import script from "./GlobalSetting.vue?vue&type=script&lang=ts"
export * from "./GlobalSetting.vue?vue&type=script&lang=ts"
import style0 from "./GlobalSetting.vue?vue&type=style&index=0&id=2a7b40c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7b40c5",
  null
  
)

export default component.exports